import { onMounted, onUnmounted, ref } from 'vue';
import { useSocketScanner } from '../../stores/socketScannerStore';
import { useScannerInput } from '../form/useScannerInput';
import { toRaw } from 'vue';

export interface ScanPattern {
  regex: RegExp;
  priority?: number;
  handler: (value: string) => boolean;
}

const registeredPatterns = ref<ScanPattern[]>([]);

const handleInput = (value: string) => {
  for (const { regex, handler } of registeredPatterns.value) {
    if (regex.test(value)) {
      const shouldContinue = handler(value);
      if (shouldContinue === false) break;
    }
  }

  return true;
};

export const useScanEvents = (patterns: ScanPattern[] = [], root?: boolean) => {
  if (root) {
    const lastScan = ref('');

    useScannerInput(lastScan, { capture: false, onInput: handleInput });
    useSocketScanner(lastScan, { prepend: true, onInput: handleInput });
  }

  onMounted(() => {
    registeredPatterns.value.push(...patterns);
    registeredPatterns.value.sort((a, b) => (b.priority ?? 0) - (a.priority ?? 0));
  });

  onUnmounted(() => {
    registeredPatterns.value = registeredPatterns.value.filter((p) => !patterns.includes(toRaw(p)));
  });

  return { handleInput };
};
